import { takeEvery, put } from "redux-saga/effects";
import { LocationChangeAction, LOCATION_CHANGE } from "react-router-redux";
import { CampaignUrl, EditCampaignUrl } from "@common";
import { CleanAdUnitBuilderAssetAction } from "../actions";
import { Action } from "redux";

export function* cleanAsset() {
    yield put(CleanAdUnitBuilderAssetAction());
}

export function* cleanAssetForms() {
    yield takeEvery(
        (a: Action) =>
            (a.type === LOCATION_CHANGE && CampaignUrl.match((a as LocationChangeAction).payload, true).isMatched) ||
            EditCampaignUrl.match((a as LocationChangeAction).payload, true).isMatched,
        cleanAsset
    );
}
